import { useEffect } from 'react';
import { useAppSelector } from '../store/hooks';
import { selectUser } from '../auth/user/store/userSlice';
import UserbackWidgetLoader from '@userback/widget';

const UserbackWidget = () => {
  const user = useAppSelector(selectUser);

  useEffect(() => {
    const userbackToken = import.meta.env.VITE_USERBACK_TOKEN;
    
    // Only initialize if token is provided and not the placeholder
    if (!userbackToken || userbackToken === 'YOUR_USERBACK_TOKEN_HERE') {
      console.warn('Userback token not configured. Please set VITE_USERBACK_TOKEN in your .env file.');
      return;
    }

    let userbackWidget: any = null;

    const initializeUserback = async () => {
      try {
        // Configure user information if user is authenticated
        if (user && user.data?.email) {
          const userName = user.first_name && user.last_name 
            ? `${user.first_name} ${user.last_name}`.trim()
            : user.data.displayName || 'Unknown User';

          // Get current organization info
          const orgIds = Object.keys(user.org_id_to_org_member_info || {});
          const currentOrgId = orgIds[0];
          const currentOrg = user.org_id_to_org_member_info?.[currentOrgId];

          // Initialize Userback widget with user data
          userbackWidget = await UserbackWidgetLoader(userbackToken, {
            name: userName,
            email: user.data.email,
            user_data: {
              id: user.uid,
              role: currentOrg?.user_role || 'unknown',
              organization: currentOrg?.org_name || 'unknown',
              organizationId: currentOrgId || 'unknown'
            }
          });

          console.log('Userback widget initialized for user:', userName);
        } else {
          // Initialize without user data if not authenticated
          userbackWidget = await UserbackWidgetLoader(userbackToken);
          console.log('Userback widget initialized without user data');
        }
      } catch (error) {
        console.error('Failed to initialize Userback widget:', error);
      }
    };

    initializeUserback();

    // Cleanup function
    return () => {
      if (userbackWidget && userbackWidget.destroy) {
        userbackWidget.destroy();
      }
    };
  }, [user]);

  return null; // This component doesn't render anything visible
};

export default UserbackWidget;